import React from 'react'

const Jva_str = () => {
    return (
        <div className='container'>
            <div class="content">
  <p id="introduction">In Java, a string is a sequence of characters. For example, <var>"hello"</var> is a string
    containing a sequence of characters <var>'h'</var>, <var>'e'</var>, <var>'l'</var>, <var>'l'</var>, and
    <var>'o'</var>.</p>

  <p>We use <strong>double quotes</strong> to represent a string in Java. For example,</p>

  <pre ><div class="containers"><span class="comment">// create a string</span> <br />
String type = <span class="plain">"Java programming"</span>;</div></pre>

  <p>Here, we have created a string variable named <var>type</var>. The variable is initialized with the string
    <code>Java Programming</code>.</p>

  <div class="note-tip">
    <p><strong>Note</strong>: Strings in Java are not primitive types (like <code>int</code>, <code>char</code>, etc).
      Instead, all strings are objects of a predefined class named <code>String</code>.</p>

    <p>And, all string variables are instances of the <code>String</code> class.</p>
  </div>

  <hr/>
  <h3 id="example">Example: Create a String in Java</h3>

  <pre class="containers" ><div class="containers"><span class="hljs-class"><span class="keywords">class</span> <span class="hljs-title">Main</span> </span>&#123; <br />
<span class="hljs-function"><span class="keywords">public</span> <span class="keywords">static</span> <span class="keywords">void</span> <span class="hljs-title">main</span><span class="library">(String[] args)</span> </span>&#123;<br />
<br />
<span class="comment">// create strings</span><br />
String first = <span class="plain">"Java"</span>;<br />
String second = <span class="plain">"Python"</span>;<br />
String third = <span class="plain">"JavaScript"</span>;<br />
<br />
<span class="comment">// print strings</span><br />
System.out.println(first);   <span class="comment">// print Java</span><br />
System.out.println(second);  <span class="comment">// print Python</span><br />
System.out.println(third);   <span class="comment">// print JavaScript</span><br />
&#125;<br />
&#125;</div></pre>

  <p>In the above example, we have created three strings named <var>first</var>, <var>second</var>, and
    <var>third</var>. Here, we are directly creating strings like primitive types.</p>

  <p>However, there is another way of creating Java strings (using the <code>new</code> keyword). We will learn about
    that later in this tutorial.</p>

  <hr/>
  <h2>Java String Operations</h2>

  <p>Java String provides various methods to perform different operations on strings. We will look into some of the
    commonly used string operations.</p>

  <h3 id="string-length">1. Get Length of a String</h3>

  <p>To find the length of a string, we use the <code>length()</code> method of the String. For example,</p>

  <pre class="containers" ><code class="containers"><span class="hljs-class"><span class="keywords">class</span> <span class="hljs-title">Main</span> </span>&#123;<br />
<span class="hljs-function"><span class="keywords">public</span> <span class="keywords">static</span> <span class="keywords">void</span> <span class="hljs-title">main</span><span class="library">(String[] args)</span> </span>&#123;<br />
<br />
<span class="comment">// create a string</span><br />
String greet = <span class="plain">"Hello! World"</span>;<br />
System.out.println(<span class="plain">"String: "</span> + greet);<br />
<br />
<span class="comment">// get the length of greet</span><br />
<span class="keywords">int</span> length = greet.length();<br />
System.out.println(<span class="plain">"Length: "</span> + length);<br />
&#125;<br />
&#125;</code></pre>

  <p><strong>Output</strong></p>

  <pre><samp>String: Hello! World
Length: 12</samp></pre>

  

  <hr/>
  <h3 id="join-strings">2. Join two Strings</h3>

  <p>We can join two strings in Java using the <code>concat()</code> method. For example,</p>

  <pre class="containers" ><code class="containers"><span class="hljs-class"><span class="keywords">class</span> <span class="hljs-title">Main</span> </span>&#123;<br />
<span class="hljs-function"><span class="keywords">public</span> <span class="keywords">static</span> <span class="keywords">void</span> <span class="hljs-title">main</span><span class="library">(String[] args)</span> </span>&#123;<br />
<br />
<span class="comment">// create first string</span><br />
String first = <span class="plain">"Java "</span>;<br />
System.out.println(<span class="plain">"First String: "</span> + first);<br />
<br />
<span class="comment">// create second</span><br />
String second = <span class="plain">"Programming"</span>;<br />
System.out.println(<span class="plain">"Second String: "</span> + second);<br />
<br />
<span class="comment">// join two strings</span><br />
String joinedString = first.concat(second);<br />
System.out.println(<span class="plain">"Joined String: "</span> + joinedString);<br />
&#125;<br />
&#125;</code></pre>

  <p><strong>Output</strong></p>

  <pre><samp>First String: Java 
Second String: Programming     
Joined String: Java Programming</samp></pre>

  <p>In the above example, we have created two strings named <var>first</var> and <var>second</var>. Notice the
    statement,</p>

  <pre ><code class="containers">String joinedString = first.concat(second);</code></pre><br /><br />

  <p>Here, we the <code>concat()</code> method joins <var>first</var> and <var>second</var> and assigns it to the<br /><br />
    <var>joinedString</var> variable.</p>

  <p>We can also join two strings using the <code>+</code> operator in Java.</p><br /><br />

  <hr/>
  <h3 id="compare-strings">3. Compare two Strings</h3>

  <p>In Java, we can make comparisons between two strings using the <code>equals()</code> method. For example,</p>

  <pre class="containers" ><code class="containers"><span class="hljs-class"><span class="keywords">class</span> <span class="hljs-title">Main</span> </span>&#123;<br />
<span class="hljs-function"><span class="keywords">public</span> <span class="keywords">static</span> <span class="keywords">void</span> <span class="hljs-title">main</span><span class="library">(String[] args)</span> </span>&#123;<br />
<br />
<span class="comment">// create 3 strings</span><br />
String first = <span class="plain">"java programming"</span>;<br />
String second = <span class="plain">"java programming"</span>;<br />
String third = <span class="plain">"python programming"</span>;<br />
<br />
<span class="comment">// compare first and second strings</span><br />
<span class="keywords">boolean</span> result1 = first.equals(second);<br />
System.out.println(<span class="plain">"Strings first and second are equal: "</span> + result1);<br />
<br />
<span class="comment">// compare first and third strings</span><br />
<span class="keywords">boolean</span> result2 = first.equals(third);<br />
System.out.println(<span class="plain">"Strings first and third are equal: "</span> + result2);<br />
&#125;<br />
&#125;</code></pre>

  <p><strong>Output</strong></p>

  <pre><samp>Strings first and second are equal: true
Strings first and third are equal: false</samp></pre>

  <p>In the above example, we have created 3 strings named <var>first</var>, <var>second</var>, and <var>third</var>.
    Here, we are using the <code>equal()</code> method to check if one string is equal to another.</p>

  <p>The <code>equals()</code> method checks the content of strings while comparing them. </p>

  <p class="note-tip"><strong>Note</strong>: We can also compare two strings using the <code>==</code> operator in Java.
    However, this approach is different than the <code>equals()</code> method. </p>

  <hr/>
  <h2 id="string-methods">Methods of Java String</h2>

  <p>Besides those mentioned above, there are various 
    present in Java. Here are some of those methods:</p>

  <div class="table-responsive">
    <table border="0">
      <tbody>
        <tr>
          <th>Methods</th>
          <th>Description</th>
        </tr>
        <tr>
          <td>substring()</td>
          <td>returns the substring of the string</td>
        </tr>
        <tr>
          <td>replace()</td>
          <td>replaces the specified old character with the specified new character</td>
        </tr>
        <tr>
          <td>charAt()</td>
          <td>returns the character present in the specified location</td>
        </tr>
        <tr>
          <td>getBytes()</td>
          <td>converts the string to an array of bytes</td>
        </tr>
        <tr>
          <td>indexOf()</td>
          <td>returns the position of the specified character in the string</td>
        </tr>
        <tr>
          <td>tocompareTo()</td>
          <td>compares two strings in the dictionary order</td>
        </tr>
        <tr>
          <td>rim()</td>
          <td>removes any leading and trailing whitespaces</td>
        </tr>
        <tr>
          <td>format()</td>
          <td>returns a formatted string</td>
        </tr>
        <tr>
          <td>split()</td>
          <td>breaks the string into an array of strings</td>
        </tr>
        <tr>
          <td>casetoLowerCase()</td>
          <td>converts the string to lowercase</td>
        </tr>
        <tr>
          <td>casetoUpperCase()</td>
          <td>converts the string to uppercase</td>
        </tr>
        <tr>
          <td>valueOf()</td>
          <td>returns the string representation of the specified argument</td>
        </tr>
        <tr>
          <td>rraytoCharArray()</td>
          <td>converts the string to a <code>char</code> array</td>
        </tr>
      </tbody>
    </table>
  </div>

  <hr/>
  <h2 id="escape-character">Escape character in Java Strings</h2>

  <p>The escape character is used to escape some of the characters present inside a string.</p>

  <p>Suppose we need to include double quotes inside a string.</p>

  <pre
    ><code class="containers"><span class="comment">// include double quote </span>
String example = <span class="plain">"This is the "</span>String<span class="plain">" class"</span>;</code></pre>

  <p>Since strings are represented by <strong>double quotes</strong>, the compiler will treat <var>"This is the "</var>
    as the string. Hence, the above code will cause an error.</p>

  <p></p>

  <div class="clearfix"></div>
  <p>To solve this issue, we use the escape character <code>\</code> in Java. For example,</p>

  <pre ><div class="containers"><span class="comment">// use the escape character</span><br />
String example = <span class="plain">"This is the \"String\" class."</span>;</div></pre>

  <p>Now escape characters tell the compiler to escape <strong>double quotes</strong> and read the whole text.</p>

  <hr/>
  <h2 id="immutable-string">Java Strings are Immutable</h2>

  <p>In Java, strings are <strong>immutable</strong>. This means, once we create a string, we cannot change that string.
  </p>

  <p>To understand it more deeply, consider an example:</p>

  <pre ><div class="containers"><span class="comment">// create a string</span><br />
String example = <span class="plain">"Hello! "</span>;</div></pre>

  <p>Here, we have created a string variable named <var>example</var>. The variable holds the string <var>"Hello!
      "</var>.</p>

  <p>Now suppose we want to change the string.</p>

  <pre ><div  class="containers"><span class="comment">// add another string "World"</span><br />
<span class="comment">// to the previous tring example</span><br />
example = example.concat(<span class="plain">" World"</span>);</div></pre>

  <p>Here, we are using the <code>concat()</code> method to add another string <var>World</var> to the previous string.
  </p>

  <p>It looks like we are able to change the value of the previous string. However, this is not <code>true</code>.</p>

  <p>Let's see what has happened here,</p>

  <ol>
    <li>JVM takes the first string <var>"Hello! "</var></li>
    <li>creates a new string by adding <var>"World"</var> to the first string</li>
    <li>assign the new string <var>"Hello! World"</var> to the <var>example</var> variable</li>
    <li>the first string <var>"Hello! "</var> remains unchanged</li>
  </ol>
  <hr/>
  <h2 id="new-keyword">Creating strings using the new keyword</h2>

  <p>So far we have created strings like primitive types in Java.</p>

  <p>Since strings in Java are objects, we can create strings using the <code>new</code> keyword as well. For example,
  </p>

  <pre
    ><div class="containers"><span class="comment">// create a string using the new keyword</span><br />
String name = <span class="keywords">new</span> String(<span class="plain">"Java String"</span>);</div></pre>

  <p>In the above example, we have created a string <var>name</var> using the <code>new</code> keyword.</p>

  <p>Here, when we create a string object, the <code>String()</code> constructor is invoked. To learn more about
    constructor, visit Java Constructor.</p>

  <p class="note-tip"><strong>Note</strong>: The <code>String</code> class provides various other constructors to create
    strings. To learn more, visit Java String
      (official Java documentation).</p>

  <hr/>
  <h3>Example: Create Java Strings using the new keyword</h3>

  <pre  ><div class="containers"><span class="hljs-class"><span class="keywords">class</span> <span class="hljs-title">Main</span> </span>&#123;<br />
<span class="hljs-function"><span class="keywords">public</span> <span class="keywords">static</span> <span class="keywords">void</span> <span class="hljs-title">main</span><span class="library">(String[] args)</span> </span>&#123;<br />
<br />
<span class="comment">// create a string using new</span><br />
String name = <span class="keywords">new</span> String(<span class="plain">"Java String"</span>);<br />
<br />
System.out.println(name);  <span class="comment">// print Java String<br />
<br />
</span>
&#125;<br />
&#125;</div></pre>

  <hr/>
  <h3 id="string-literal-vs-new">Create String using literals vs new keyword</h3>

  <p>Now that we know how strings are created using string literals and the <code>new</code> keyword, let's see what is
    the major difference between them.</p>

  <p>In Java, the JVM maintains a <strong>string pool</strong> to store all of its strings inside the memory. The string
    pool helps in reusing the strings.</p>

  <p>1. While creating strings using string literals,</p>

  <pre
    ><code class="containers">String example = <span class="plain">"Java"</span>;</code></pre>

  <p>Here, we are directly providing the value of the string (<code>Java</code>). Hence, the compiler first checks the
    string pool to see if the string already exists.</p>

  <ul>
    <li><strong>If the string already exists</strong>, the new string is not created. Instead, the new reference,
      <var>example</var> points to the already existed string (<code>Java</code>).</li>
    <li><strong>If the string doesn't exist</strong>, the new string (<code>Java</code> is created.</li>
  </ul>
  <p>2. While creating strings using the new keyword,</p>

  <pre
    ><code class="containers">String example = <span class="keywords">new</span> String(<span class="plain">"Java"</span>);</code></pre>

  <p>Here, the value of the string is not directly provided. Hence, the new string is created all the time.</p>
</div>
        </div>
    )
}

export default Jva_str
